<template>
  <article>
    <section class="w-full">
      <div class="banner w-full lg:h-18 md:h-60 h-48 relative">
        <div class="flex items-center flex-column w-full h-full">
          <div class="container mx-auto">
            <div class="flex flex-col items-center w-full container">
              <divider-component>Menu</divider-component>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      v-if="loading === false"
      class="bg-gray-200 h-14 w-full flex items-center sticky top-0 drop-shadow-sm"
    >
      <!-- Categories navbar -->
      <div
        class="flex container md:justify-around items-center lg:mx-64 mx-6 md:overflow-auto overflow-scroll"
      >
        <a
          v-for="(categorie, catIndex) in categories"
          :key="catIndex"
          :class="{
            'bg-pink-700': catIndex == selectedCategory,
            'text-white': catIndex == selectedCategory,
            'rounded-md': catIndex == selectedCategory,
          }"
          :href="'#' + categorie"
          class="p-2 text-center whitespace-nowrap font-medium"
          @click="selectedCategory = catIndex"
          >{{ categorie }}</a
        >
      </div>
    </section>
    <!-- Categorie box -->
    <section v-if="loading === false" class="h-full w-full flex items-center mt-8">
      <div class="container lg:mx-96 mx-6">
        <div
          v-for="(cat, index) in menu"
          :key="index"
          :class="{ 'mt-0': index === 0 }"
          class="lg:my-10 my-6"
        >
          <!-- Header -->
          <div
            :id="cat.title"
            class="bg-pink-700 text-white font-bold px-4 lg:py-3 py-2 flex justify-between anchor"
          >
            <!-- Title -->
            <h3 class="lg:text-2xl text-md lg:w-3/4 w-2/4">{{ cat.title }}</h3>
            <!-- Prices -->
            <div
              v-if="cat.sizes.length > 1"
              class="lg:text-md text-sm flex flex-row justify-between lg:w-1/4 w-2/4 text-center"
            >
              <h3 v-for="(size, sizeIndex) in cat.sizes.reverse()" :key="sizeIndex" class="w-1/4">
                {{ size.title }}
              </h3>
            </div>
          </div>
          <!-- Content  -->
          <div class="bg-white">
            <!-- Item -->
            <div v-for="(item, i) in cat.items.reverse()" :key="i">
              <div class="w-full flex justify-between px-4 py-3">
                <!-- Item left side -->
                <div class="flex flex-col lg:w-3/4 w-2/4">
                  <h3 class="text-gray-600 lg:text-lg text-sm font-bold">
                    {{ item.name }}
                  </h3>
                  <p class="text-gray-400 lg:text-sm text-xs font-medium leading-3">
                    {{ item.ingredients }}
                  </p>
                </div>
                <!-- item right side -->
                <div
                  :class="item.prices.length > 1 ? 'justify-between' : 'justify-end'"
                  class="lg:text-md text-sm flex flex-row lg:w-1/4 w-2/4"
                >
                  <h3
                    v-for="(price, priceIndex) in item.prices.reverse()"
                    :key="priceIndex"
                    class="text-pink-800 lg:text-md text-sm font-bold text-center w-1/4 whitespace-nowrap"
                  >
                    <span v-if="price.value !== ''">€{{ price.value }}</span>
                  </h3>
                </div>
              </div>
              <div
                v-if="i !== cat.items.length - 1"
                class="h-px w-full bg-pink-900 bg-opacity-25"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import Menu from '@/assets/menu.json';
import DividerComponent from '@/components/util/Divider.component.vue';

export default defineComponent({
  name: 'Menu-page',
  components: { DividerComponent },
  setup() {
    const menu = Menu;
    const categories: Array<string> = [];
    const loading = ref(true);
    const selectedCategory = ref(0);

    menu.forEach((m) => {
      categories.push(m.title);
    });

    loading.value = false;

    return { menu, categories, loading, selectedCategory };
  },
});
</script>

<style lang="scss" scoped>
.anchor {
  scroll-margin-top: 4rem;
}
</style>
